const DONATION_STEPS = Object.freeze({
  BASKET_CREATION: 'BASKET_CREATION',
  DONOR_INFORMATION: 'DONOR_INFORMATION',
  PAYMENT: 'PAYMENT',
  THANKS: 'THANKS',
  FAILED: 'FAILED',
  PROFILE: 'PROFILE'
});

const TITLE_OPTIONS = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Miss', label: 'Miss' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Prof', label: 'Prof' },
  { value: 'Sheikh', label: 'Sheikh' },
  { value: 'Imam', label: 'Imam' }
];

const PHONE_NUMBER_TYPE_OPTIONS = [
  { value: 'personal', label: 'Personal' },
  { value: 'home', label: 'Home' },
  { value: 'office', label: 'Office' },
  { value: 'office_2', label: 'Office 2' }
];

const HEAR_ABOUT_US_OPTIONS = [
  { value: 'Search Engine / Online', label: 'Search Engine / Online' },
  { value: 'Family or Friends', label: 'Family or Friends' },
  { value: 'Instagram', label: 'Instagram' },
  { value: 'Facebook', label: 'Facebook' },
  { value: 'TikTok Post', label: 'TikTok Post' },
  { value: 'TikTok Live', label: 'TikTok Live' },
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'Snapchat', label: 'Snapchat' },
  { value: 'Other Social Media', label: 'Other Social Media' },
  { value: 'Email Newsletter', label: 'Email Newsletter' },
  { value: 'SMS Text Message', label: 'SMS Text Message' },
  { value: 'Masjid', label: 'Masjid' },
  { value: 'Event', label: 'Event' },
  { value: 'Podcast', label: 'Podcast' },
  { value: 'Billboard Poster', label: 'Billboard Poster' },
  { value: 'Help Yateem Website', label: 'Help Yateem Website' },
  { value: 'Eman Channel', label: 'Eman Channel' },
  { value: 'Live TV Appeal', label: 'Live TV Appeal' },
  { value: 'Other', label: 'Other' }
];

export { DONATION_STEPS, TITLE_OPTIONS, PHONE_NUMBER_TYPE_OPTIONS, HEAR_ABOUT_US_OPTIONS };
